import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const SiteContext = createContext(null);

const DEFAULT = {
  settings: {
    brand: {
      name: "TST & MK GROUP",
      tagline: "Engineered by Excellence",
      established: "2005",
      city: "Visakhapatnam",
      logoUrl: "https://customer-assets.emergentagent.com/job_tst-mk-industrial/artifacts/yqb6wee8_03A2FA0E-9401-4200-9C01-8EF91559FB13.png",
      email: "info@tstmkgroup.com",
      phone: "+91 98765 43210",
      address: "Visakhapatnam, Andhra Pradesh, India",
      working_hours: "Mon – Sat · 9:00 – 18:30",
    },
    hero: {
      image: "",
      eyebrow: "Since 2005 · Visakhapatnam",
      headline_top: "Heavy Industry,",
      headline_accent: "Engineered",
      headline_tail: "by Excellence.",
      subtitle: "",
    },
    stats: [],
    about: { headline: "", intro: "", story_paragraphs: [], story_image: "", mission: "", vision: "", values: [] },
    industries: [],
    footer_note: "ISO 9001 · IS 7205 · HSE COMPLIANT",
  },
  services: [],
  clients: [],
  testimonials: [],
  positions: [],
  leaders: [],
  projects: [],
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export function absoluteUrl(url) {
  if (!url) return url;
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export function SiteProvider({ children }) {
  const [data, setData] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data: res } = await api.get("/site");
      setData({ ...DEFAULT, ...res, settings: { ...DEFAULT.settings, ...res.settings } });
    } catch (e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContext.Provider value={{ ...data, loading, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext) || { ...DEFAULT, loading: true, refresh: () => {} };
}
